import { DeliveryType } from 'src/api/@generated/backend-api';

import { RootState } from 'src/state/types';

import { OrderStep, ProductDetailsPage } from './types';

export const selectLastVisitedProductDetailsPage = (state: RootState): ProductDetailsPage | undefined =>
  state.order.lastVisitedProductDetailsPage;

export const selectReachedStep = (state: RootState): OrderStep => state.order.reachedStep;

export const selectDeliveryType = (state: RootState): DeliveryType => state.order.selectedDeliveryType;
